import React from "react";
import { useNavigate } from "react-router-dom";

const ServiceDetails = ({ service }) => {
  const navigate = useNavigate();

  const handlePurchase = (heading, price, duration) => {
    navigate(`/payment?service=${heading}&price=${price}&duration=${duration}`);
  };

  const durations = ["weekly", "monthly", "quarterly", "halfYearly", "yearly"];

  return (
    <div className="min-h-screen py-10 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto space-y-12 text-[#1F2937]">
        <h1 className="font-bold text-4xl sm:text-5xl text-center text-[#0F172A] leading-snug">
          {service.heading}
        </h1>

        <div className="grid gap-8 items-start lg:grid-cols-2">
          <p className="leading-relaxed text-base md:text-lg lg:text-xl">
            {service.description}
          </p>

          <div className="overflow-x-auto rounded-lg shadow-2xl">
            <table className="w-full table-auto text-sm sm:text-base">
              <thead className="bg-[#0F172A] text-white">
                <tr>
                  <th className="p-4">Duration</th>
                  <th className="p-4">Price</th>
                  <th className="p-4">Action</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {durations.map((duration, index) => (
                  <tr key={duration} className="text-center">
                    <td className="p-4 capitalize">{duration}</td>
                    <td className="p-4">
                      {(service.prices[index][duration]) || "-"}
                    </td>
                    <td className="p-4">
                      {service.prices[index][duration] ? (
                        <button
                          onClick={() => handlePurchase(service.heading, service.prices[index][duration], duration)}
                          className="bg-gray-200 text-[#1F2937] font-medium px-4 py-2 rounded-lg hover:bg-gray-300 transition-transform transform hover:scale-105 focus:outline-none"
                        >
                          Buy Now
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="space-y-8">
          {service.features && (
            <div>
              <h3 className="text-2xl font-semibold mb-4">Features</h3>
              <ul className="space-y-3">
                {service.features.map((feat, i) => (
                  <li key={i} className="flex items-center">
                    <span className="mr-3 text-blue-500">✔️</span> {feat}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {service.investmentRules?.length > 0 && (
            <div>
              <h3 className="text-2xl font-semibold mb-4">Investment Rules</h3>
              <ul className="space-y-3">
                {service.investmentRules.map((rule, i) => (
                  <li key={i} className="flex items-center">
                    <span className="mr-3 text-red-500">📌</span> {rule}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {service.callPattern && (
            <div>
              <h3 className="text-2xl font-semibold mb-4">Call Pattern</h3>
              <ul className="space-y-3">
                {service.callPattern.map((pattern, i) => (
                  <li key={i} className="flex items-center">
                    <span className="mr-3 text-green-500">📞</span> {pattern}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {service.sample && (
            <div>
              <p className="mt-4">
                <span className="font-bold">Sample:</span> {service.sample}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceDetails;
